import { CountPillGrey } from "./CountPillGrey";

export default CountPillGrey;
